module.exports = __webpack_public_path__ + "img/search.e3a159b9.svg";